// extracted by mini-css-extract-plugin
export var required = "_gs-0";